import React, { useEffect, useRef, useState } from "react";
import shareYourIdeasWithUs from "../../assets/images/share-your-ideas-with-us.webp";
import parallexImg from "../../assets/images/parallex-bg.avif";
 import companyBadge from "../../assets/images/top-mobile-app-development-company-badge.webp";
import TopDevelopersLogo from "../../assets/images/TopDevelopers-Logo.webp";
import aws1 from "../../assets/images/AWS-certified-systems-architect-certification-logo.webp";
import aws2 from "../../assets/images/AWS-certified-cloud-practitioner-certification-logo.webp";
import SwiperComponent from "../../components/SwiperComponent";
import { Link } from "react-router-dom";
import { routes } from "../../config/utilities/utils.constant";
import thumbtack from "../../assets/images/Thumbtack-logo-for-Apptalyst-profile.svg";
import google from "../../assets/images/GoogleMyBusiness-logo-for-Apptalyst-profile.webp";
import clutch from "../../assets/images/Clutch-logo-for-Apptalyst-profile.svg";
import sortlist from "../../assets/images/Sortlist-logo-for-Apptalyst-profile.svg";
import designRush from "../../assets/images/DesignRush-logo-for-Apptalyst-profile.webp";
import goodfirms from "../../assets/images/GoodFirms-logo-for-Apptalyst-profile.svg";
import TechBehemoths from "../../assets/images/TechBehemoths-logo-for-Apptalyst-profile.webp";
import blog1 from "../../assets/images/meeting-with-client-for-gathering-requirements.avif";
import blog2 from "../../assets/images/brainstorming-the-best-software-solutions.avif";
import blog3 from "../../assets/images/website-designers-discussing-low-fidelity-mockups.avif";
import blog4 from "../../assets/images/coding-on-a-computer.avif";
import blog5 from "../../assets/images/software-testing.avif";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";
import HomeBanner from "./HomeBanner";
import ContactForm from "../../components/ContactForm";
import SliderComponent from "./SliderComponent";
import ServicesNameAnimation from "./ServicesNameAnimation";
import SwipAnimation from "./SwipAnimation";

const process = [
  {
    title: "Discovery & Requirements Gathering",
    image: blog1,
    description:
      "We listen first and listen well, making sure you’re heard and understood before being presented with a solution for your vision and goals. ",
  },
  {
    title: "Ideation  & Planning",
    image: blog2,
    description:
      "Our experts brainstorm the smartest technical solution to your requirements and present the actionable software architecture and workflows.",
  },
  {
    title: "Design & prototyping",
    image: blog3,
    description:
      "Aesthetically pleasing mockups for the software’s user-interface are presented which are further elaborated by interactive prototyping to demonstrate the software’s functionality and user-experience. ",
  },
  {
    title: "Development & testing",
    image: blog4,
    description:
      "Our in-house team of specialists executes the full-stack coding of software, while ensuring top-notch quality assurance protocols at each stage.  ",
  },
  {
    title: "Deployement & Maintenance",
    image: blog5,
    description:
      "From hassle-free launch to consistent support and upgrades, we’ve got you covered.  ",
  },
];

const array1 = [
  {
    icon: clutch,
    siteLink: "https://clutch.co/profile/apptalyst",
    altAttribute: "Clutch logo, Apptalyst is on Clutch to cater B2B clients.",
  },
  {
    icon: clutch,
    siteLink: "https://clutch.co/profile/apptalyst",
    altAttribute: "Clutch logo, Apptalyst is on Clutch to cater B2B clients.",
  },
  
];
const array2 = [
  {
    icon: aws1,
    siteLink: "",
    altAttribute:
      "AWS Systems Architect certification logo, since project managers and business analysts at Apptalyst have this certification.",
  },
  {
    icon: aws2,
    siteLink: "",
    altAttribute:
      "AWS cloud certification logo. DevOps team at Apptalyst, has this certification.",
  },
];

const array3 = [
  {
    icon: sortlist,
    siteLink: "https://www.sortlist.com/agency/apptalyst",
    altAttribute: "Sortlist logo, where Apptalyst serves clients globally. ",
  },
  {
    icon: designRush,
    siteLink: "https://www.designrush.com/agency/profile/apptalyst",
    altAttribute:
      "DesignRush logo, where Apptalyst is listed in Best App Development Companies.",
  },
];
const array4 = [
  {
    icon: thumbtack,
    siteLink: "",
    altAttribute:
      "Thumbtack logo, where Apptalyst serves the digital needs of small businesses.",
  },
  {
    icon: google,
    siteLink: "",
    altAttribute:
      "Google My Business logo, Apptalyst’s location is pinned on Google Maps.",
  },
];
const array5 = [
  {
    icon: companyBadge,
    siteLink: "https://topfirms.co/companies/mobile-app-development/usa",
    altAttribute: "eCommerce Development Companies",
  },
  {
    icon: TopDevelopersLogo,
    siteLink: "https://www.topdevelopers.co/",
    altAttribute: "External link to topdevelopers.co",
  },
];
const array6 = [
  {
    icon: goodfirms,
    siteLink: "https://www.goodfirms.co/company/apptalyst",
    altAttribute: "GoodFirms logo, click to view the ratings for Apptalyst.",
  },
  {
    icon: TechBehemoths,
    siteLink: "https://techbehemoths.com/company/apptalyst",
    altAttribute:
      "TechBehemoths logo, where Apptalyst is listed in Top IT Companies in Fairfax, United States.  ",
  },
];

const Home = () => {
  const  jsonLd =
{
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "Apptalyst",
  "alternateName": "Apptalyst LLC",
  "image": "https://apptalyst.com/assets/logo-wFOx7_jU.webp",
  "@id": "https://apptalyst.com/#organization",
  "url": "https://apptalyst.com",
  "telephone": "+1-703-381-2998",
  "email": "info@apptalyst.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "11819 Thomas Ave",
    "addressLocality": "Great Falls",
    "addressRegion": "VA",
    "postalCode": "22066",
    "addressCountry": "US"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 38.9987,
    "longitude": -77.2922
  },
  "founder": [
    {
      "@type": "Person",
      "name": "Affan Salim",
      "jobTitle": "Founding Partner & Chief Technology Officer",
      "sameAs": "https://pk.linkedin.com/in/affan-salim-51ba3524a"
    },
    {
      "@type": "Person",
      "name": "Shahan Salam",
      "jobTitle": "Founding Partner & Chief Executive Officer",
      "sameAs": "https://www.linkedin.com/in/shahansalam"
    }
  ],
  "areaServed": [
    {
      "@type": "Country",
      "name": "United States"
    },
    {
      "@type": "State",
      "name": "Virginia"
    },
    {
      "@type": "State",
      "name": "Maryland"
    },
    {
      "@type": "City",
      "name": "Washington DC"
    },
    {
      "@type": "City",
      "name": "Great Falls"
    },
    {
      "@type": "City",
      "name": "Fairfax"
    },
    {
      "@type": "City",
      "name": "Tysons"
    },
    {
      "@type": "City",
      "name": "Reston"
    },
    {
      "@type": "City",
      "name": "Herndon"
    },
    {
      "@type": "City",
      "name": "Ashburn"
    },
    {
      "@type": "City",
      "name": "McLean"
    },
    {
      "@type": "City",
      "name": "Vienna"
    },
    {
      "@type": "City",
      "name": "Arlington"
    },
    {
      "@type": "City",
      "name": "Alexandria"
    },
    {
      "@type": "City",
      "name": "Falls Church"
    },
    {
      "@type": "City",
      "name": "Leesburg"
    },
    {
      "@type": "City",
      "name": "Sterling"
    },
    {
      "@type": "City",
      "name": "Chantilly"
    },
    {
      "@type": "City",
      "name": "Centreville"
    },
    {
      "@type": "City",
      "name": "Manassas"
    },
    {
      "@type": "City",
      "name": "Woodbridge"
    },
    {
      "@type": "City",
      "name": "Richmond"
    },
    {
      "@type": "City",
      "name": "Virginia Beach"
    },
    {
      "@type": "City",
      "name": "Norfolk"
    },
    {
      "@type": "City",
      "name": "Chesapeake"
    },
    {
      "@type": "City",
      "name": "Bethesda",
      "description": "Maryland"
    },
    {
      "@type": "City",
      "name": "Silver Spring",
      "description": "Maryland"
    },
    {
      "@type": "City",
      "name": "Rockville",
      "description": "Maryland"
    },
    {
      "@type": "City",
      "name": "Gaithersburg",
      "description": "Maryland"
    },
    {
      "@type": "City",
      "name": "Potomac",
      "description": "Maryland"
    },
    {
      "@type": "City",
      "name": "Chevy Chase",
      "description": "Maryland"
    },
    {
      "@type": "City",
      "name": "National Harbor",
      "description": "Maryland"
    }
  ],
  "sameAs": [
    "https://www.linkedin.com/company/apptalyst-llc/",
    "https://clutch.co/profile/apptalyst",
    "https://www.crunchbase.com/organization/apptalyst",
    "https://www.designrush.com/agency/profile/apptalyst",
    "https://www.goodfirms.co/company/apptalyst",
    "https://techbehemoths.com/company/apptalyst",
    "https://www.sortlist.com/agency/apptalyst",
    "https://www.trustpilot.com/review/apptalyst.com",
    "https://themanifest.com/company/apptalyst",
    "https://www.topdevelopers.co/profile/apptalyst",
    "https://topfirms.co/company-detail/5597/apptalyst",
    "https://patch.com/virginia/great-falls-va/business/listing/553622/apptalyst",
    "https://medium.com/@apptalyst",
    "https://www.pinterest.com/Apptalyst/",
    "https://github.com/Apptalyst"
  ],
  "knowsAbout": [
    "TypeScript",
    "React",
    "React Native",
    "Next.js",
    "Vue.js",
    "Flutter",
    "Swift",
    "Java",
    "C++",
    "C",
    "Python",
    "IoT Firmware",
    "Embedded Systems",
    "Edge Computing",
    "Microservices Architecture",
    "Server Side Rendering (SSR)",
    "Static Site Generation (SSG)",
    "AWS IoT Core",
    "Google PPC",
    "Google AdSense"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Digital Services",
    "itemListElement": [
      {
        "@type": "OfferCatalog",
        "name": "Mobile App Development",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Cross-Platform Mobile App Development",
              "description": "React Native and Flutter development for iOS and Android."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Native Mobile App Development",
              "description": "Native Swift and Java/Kotlin development."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Mobile App Prototyping & Wireframing"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Web Development",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Web Application Development",
              "description": "Custom web apps using React, TypeScript, and Microservices."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "CMS Development",
              "description": "Headless CMS and custom content management systems."
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "IoT Solutions",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IoT Programming & App Development"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "IoT Assembly & Embedded Systems"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Design Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "UI/UX Design"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Logo & Graphic Design"
            }
          }
        ]
      },
      {
        "@type": "OfferCatalog",
        "name": "Digital Marketing",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "SEO & Social Media Management"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "PPC & Performance Marketing"
            }
          }
        ]
      }
    ]
  }
}
  return (
    <>
      <Head>
        <title>Apptalyst: Accelerating Growth with Digital Solutions</title>
        <meta
          name="description"
          content="Apptalyst is an expert software development & digital marketing company in Great Falls, VA. We help businesses kick-start their online journeys & solve key challenges."
        />
        <link rel="canonical" href="https://apptalyst.com/" />
     <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
        {/* <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(jsonLd),
    }}
  /> */}
      </Head>
      <HomeBanner />

      <div className="space-y-20 md:space-y-32">
        <div className="container space-y-10">
          <div className="   flex flex-col md:flex-row justify-center items-center  md:justify-between md:space-x-8 space-y-10 md:space-y-0 px-5 md:px-3">
            <SwipAnimation logos={array1} duration={2500} />
            <SwipAnimation logos={array2} duration={2500} />
            <SwipAnimation logos={array3} duration={2500} />
          </div>
          <div className="   flex flex-col md:flex-row justify-center items-center  md:justify-between md:space-x-8 space-y-10 md:space-y-0 px-5 md:px-3">
            <SwipAnimation logos={array4} duration={2500} />
            <SwipAnimation logos={array5} duration={2500} />
            <SwipAnimation logos={array6} duration={2500} />
          </div>
        </div>

        <div className="container  xl:px-20">
          <SliderComponent title="Our Experties" />
        </div>
        <div
          className="relative bg-heropattern bg-cover bg-center bg-fixed h-[400px] md:h-[325px]"
          style={{ backgroundImage: `url(${parallexImg})` }}
          alt="A bustling and progressive city at night time."
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#6D1349]/60 to-[#DF73FF]/40 z-0">
            <div className="container flex flex-col md:flex-row items-center justify-center h-full z-10 ">
              <div className="flex flex-col xl:flex-row items-center justify-center w-full  xl:space-x-4  space-y-4 xl:space-y-0 ">
                <h2 className="text-3xl sm:text-4xl  text-white font-semibold text-center xl:text-start  xl:w-5/12 2xl:w-auto">
                  Catalytic brainstorming for{" "}
                </h2>
                <ServicesNameAnimation />
                {/* <div className="w-full    max-[1700px]:w-auto  bg-red-900 "> */}
                <div className=" w-[13.5rem]   mobSmallScreen:w-[293px] sm:w-auto ">
                  <Link
                    to={routes.CONTACTUS}
                    aria-label="Internal link to Contact Us page"
                  >
                    <button title="Get Started" className="  px-6 py-4 bg-[#FFC067] text-dark font-bold rounded shadow w-full md:wauto text-base  md:text-lg transition c4">
                      Get Started
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <SwiperComponent description={true} process={process} />
        </div>

        <div>
          <div className="  bg-gray-50  py-20 md:py-32">
            {/* <div className='max-w-screen-lg xl:max-w-screen-xl  mx-auto py-20 px-5 md:px-10 lg:px-20 '> */}
            <div className="container  ">
              <div className="mb-4 block px-4 md:hidden">
                <motion.h2
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                  className="text-2xl font-bold text-center mb-4"
                >
                  Partner with Apptalyst for execution of your innovative
                  ideas.{" "}
                </motion.h2>
                <h3 className="font-semibold mb-6 text-xl text-center">
                  Schedule a free consultation & brainstorming session.
                </h3>
              </div>
              <div className="flex flex-col md:flex-row md:space-x-0 ">
                <div className="md:w-2/5 space-y4 p4 pb-7 md:py-10 ">
                  <div className="mb-4 hidden md:block pl-4 pr-5 lg:pr-10">
                    <motion.h2
                      initial={{ opacity: 0, y: 40 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8, ease: "easeOut" }}
                      className="text-2xl font-bold mb-4 text-dark"
                    >
                      Partner with Apptalyst for execution of your innovative
                      ideas.
                    </motion.h2>
                    <h3 className="font-semibold mb-6 text-xl text-dark">
                      Schedule a free consultation & brainstorming session.
                    </h3>
                  </div>

                  <div className=" ">
                    <img
                      loading="lazy"
                      src={shareYourIdeasWithUs}
                      alt="A colorful bulb representing creative ideas and the branding of Apptalyst."
                      className="mx- w-full sm:w-6/12 md:w-9/12 ml-auto h-full mt-0 md:mt-20"
                      width={400}
                      height={400}
                    />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
